import {TransactionProduct} from 'app/modules/transaction_product/_models.ts'

const initTransferCartState: TransactionProduct[] = []

export const transferCartTypes = {
  ADD_ITEM_TO_CART: 'ADD_ITEM_TO_TRANSFER_CART',
  ADD_ITEMS_TO_CART: 'ADD_ITEMS_TO_TRANSFER_CART',
  DELETE_FROM_CART: 'DELETE_FROM_TRANSFER_CART',
  CLEAR_CART: 'CLEAR_TRANSFER_CART',
}

export const transferCartActions = {
  addItem: async (obj: TransactionProduct) => ({type: transferCartTypes.ADD_ITEM_TO_CART, obj}),
  addItems: async (obj: TransactionProduct[]) => ({type: transferCartTypes.ADD_ITEMS_TO_CART, obj}),
  deleteItem: async (key: string) => ({type: transferCartTypes.DELETE_FROM_CART, key}),
  clearCart: async () => ({type: transferCartTypes.CLEAR_CART}),
}

const transferCartReducer = (state = initTransferCartState, action: any) => {
  switch (action.type) {
    case transferCartTypes.ADD_ITEM_TO_CART:
      const existingItemIndex = state.findIndex((item) => item.key === action.obj.key)
      if (existingItemIndex !== -1) {
        const updatedState = [...state]
        const existingItem = updatedState[existingItemIndex]
        existingItem.data!.quantity += action.obj.data.quantity
        return updatedState
      }
      return [...state, action.obj]
    case transferCartTypes.ADD_ITEMS_TO_CART:
      return action.obj
    case transferCartTypes.DELETE_FROM_CART:
      return state.filter((item) => item.key !== action.key)
    case transferCartTypes.CLEAR_CART:
      return []
    default:
      return state
  }
}

export {transferCartReducer}
